import type { Order } from '../types';

export class PaginationParams {
  limit?: number = 10;

  offset?: number = 0;

  sortBy?: string;

  order?: Order = 'desc';
}

export class BasicPaginationParams {
  limit?: number = 40;

  offset?: number = 0;
}
